import React from 'react';

import { STYLE } from '../constants';

export function Separator() {
  return <div className={STYLE.separator} />;
}
